import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import CGOFlowTables from "./CGOFlowTables";
import btnDownloadIcon from "./../../Assests/download.svg";
import {
  ViewProductTableError,
  ViewProductTableStart,
  ViewProductTableSuccess,
} from "../../Redux/Actions/InputData";
import {
  API_BASE_URL,
  DISPLAY_LANDED_COST_API,
  DOWNLOAD_LANDED_COST_TABLE_API,
  VIEW_LANDED_COST_TABLE_API,
  HOME_FLOW_DROPDOWN_FILTER_API,
  HOMECARE_GET_TABLE_API,
  NUTRITION_GET_TABLE_API,
  CGO_FLOW_OUTPUT_API,
  CGO_FLOW_OUTPUT2_API,
  CGO_FLOW_OUTPUT_API_DOWNLOAD,
  CGO_FLOW_OUTPUT2_API_DOWNLOAD
} from "../../Utils/Config";
import { getRequest, postRequest } from "../../Services/AxiosConfiguration";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import axios from "axios";
import FileSaver from "file-saver";
import "./style.css";
import * as actions from "../../Redux/Actions/index";

function LandedCost(props: any) {
  const dispatch: any = useDispatch();
  const [selectFactory, setSelectFactory] = useState<any>("");
  const [selectBasepack, setSelectBasepack] = useState<any>("");
  const [selectLine, setSelectLine] = useState<any>("");
  const [selectTimePeriod, setSelectTimePeriod] = useState<any>("");
  const [rowsData, setRows] = React.useState([]);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [factoryOptions, setFactoryOptions] = React.useState([]);
  const [basepackOptions, setBasepackOptions] = useState<any>([]);
  const [lineOptions, setLineOptions] = useState<any>([]);
  const [timePeriodOptions, setTimePeriodOptions] = useState<any>([]);
  const [pageIsLoaded, setPageIsLoaded] = useState<any>(false);
  const [tableColumnsDef, setTableColumnsDef] = useState<any>([]);
  // const [filterRequest, setFilterRequest] = React.useState([{"key":"factory","value":""},{"key":"line","value":""},{"key":"basepack","value":""},{"key":"time_period","value":""}]);
  const [filterRequest, setFilterRequest] = React.useState([
    { key: "factory", value: "" },
    { key: "basepack", value: "" },
    { key: "time_period", value: "" },
  ]);

  const sortedFactoryNames = factoryOptions.sort((a: any, b: any) =>
    a?.factory_Name.localeCompare(b?.factory_Name)
  );

  //flow dropdown filter options
  const [filterDropdownOptions, setFilterDropdownOptions] = useState<any>([
    {
      displayName: "Volume Flow Output-1",
      flowTableName: "Volume Flow Output-Capacity Flow"
    },
    {
      displayName: "Volume Flow Output-2",
      flowTableName: "Volume Flow Output-Capacity Distance"
    }
  ]);
  const [selectFlowFilterOption, setSelectFlowFilterOption] = useState<any>({
    displayName: "Volume Flow Output-1",
    flowTableName: "Volume Flow Output-1"
  });
  const [pritransportationalco2Data, setPritransportationalco2Data] =
    useState<any>([]);

  var base = 0;
  var time = 0;

  /**Redux state */
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId
  );

  if (selectedFolderId) {
    console.log("selectedScenarioId", selectedScenarioId);
  }

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );

  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );

  if (selectedUsecaseId) {
    console.log("InputData Modal selectedUsecaseId: ", selectedUsecaseId);
  }
  useEffect(() => {
    if (
      selectedUsecaseId === undefined ||
      selectedCategoryId === undefined ||
      selectedFolderId === undefined ||
      selectedScenarioId === undefined
    ) {
      setPageIsLoaded(true);
    } else {
      setPageIsLoaded(false);
    }
  }, []);
  useEffect(() => {
    if (selectedScenarioId) {
      callTableGridApi("", "dropdown");
    }
  }, [selectedScenarioId])
  const handleChangeSelectFlowFilter = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectFlowFilterOption(value);
    callTableGridApi(value, "dropdown");
  };

  const selectedTimePeriodData = useSelector(
    (state: any) => state.InputDataReducers.selectedTimePeriodData
  );

  function toCamelCase(inputString: string) {
    return inputString.replace(/\w\S*/g, function (txt) {
      return (
        txt.charAt(0).toUpperCase() +
        txt.substr(1).toLowerCase().replaceAll("_", " ")
      );
    });
  }
  const callTableGridApi = (value?: any, type?: string) => {
    console.log('value', value);
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      // table: 'flow_analysisoutput_cog',
      table: value && value?.displayName.includes('2') ? 'flow_analysisplantoutput_COG' : 'flow_analysisoutput_cog',
      filter: [],
    };
    let url = "";
    dispatch(ViewProductTableStart());

    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    const apiUrl = value && value?.displayName.includes('2') ? CGO_FLOW_OUTPUT2_API : CGO_FLOW_OUTPUT_API
    postRequest(
      API_BASE_URL + apiUrl,
      requestParam,
      header,
      {}
    )
      .then((response) => {
        if (response.status === 200 && response.data) {
          if (type === "dropdown") {
            setIsProcessed(true);
            setRows(response.data);
            const columns: any = [];
            if (response.data) {
              Object.keys(response.data[0]).map((col) => {
                if (col !== "scenario_id" && col !== "folder_Id" && col.toLowerCase() !== 'id') {
                  columns.push({
                    id: col,
                    label: toCamelCase(col),
                    minWidth: 100,
                    fontWeight: 600,
                  });
                }
              });
            }
            console.log(columns, "columnsssssss");
            if (columns.length > 0) {
              setTableColumnsDef(columns);
            }
          }
          else {
            // let blob = new Blob([response.data], {
            //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            // });
            // //FileSaver(blob, Date.now() + '.xlsx');
            // FileSaver(blob, "Optimized Output.xlsx");

            axios({ url: API_BASE_URL + apiUrl, method: 'post', responseType: 'arraybuffer', headers: { 'Content-Type': 'application/json;' }, data: requestParam }).then((response) => {
              let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              FileSaver(blob, "Optimized Output" + '.xlsx');
            });
          }
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const callTableGridApiDownload = (value?: any, type?: string) => {
    console.log('value.....', value);
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: value && value?.displayName.includes('2') ? 'flow_analysisplantoutput_COG' : 'flow_analysisoutput_cog',
      filter: [],
    };
    let url = "";
    dispatch(ViewProductTableStart());

    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    const apiUrl = value && value?.displayName.includes('2') ? CGO_FLOW_OUTPUT2_API_DOWNLOAD : CGO_FLOW_OUTPUT_API_DOWNLOAD
    postRequest(
      API_BASE_URL + apiUrl,
      requestParam,
      header,
      {}
    )
      .then((response) => {
        if (response.status === 200 && response.data) {
          if (type === "dropdown") {
            setIsProcessed(true);
            setRows(response.data);
            const columns: any = [];
            if (response.data) {
              Object.keys(response.data[0]).map((col) => {
                if (col !== "scenario_id" && col !== "folder_Id" && col.toLowerCase() !== 'id') {
                  columns.push({
                    id: col,
                    label: toCamelCase(col),
                    minWidth: 100,
                    fontWeight: 600,
                  });
                }
              });
            }
            console.log(columns, "columnsssssss");
            if (columns.length > 0) {
              setTableColumnsDef(columns);
            }
          }
          else {
            // let blob = new Blob([response.data], {
            //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            // });
            // //FileSaver(blob, Date.now() + '.xlsx');
            // FileSaver(blob, "Optimized Output.xlsx");

            axios({ url: API_BASE_URL + apiUrl, method: 'post', responseType: 'arraybuffer', headers: { 'Content-Type': 'application/json;' }, data: requestParam }).then((response) => {
              let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              FileSaver(blob, "Optimized Output" + '.xlsx');
            });
          }
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  useEffect(() => {
    const requestParam = {
      usecase_id: selectedUsecaseId,
      category_id: selectedCategoryId,
    };
    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + HOME_FLOW_DROPDOWN_FILTER_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(urls, requestParam, header)
      .then((response) => {
        if (response.status === 200 && response.data) {
          console.log("responsedata", response.data);
          // setFilterDropdownOptions(response.data);
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  }, [selectedUsecaseId, selectedCategoryId]);


  const handleDownload = (e: any) => {
    callTableGridApiDownload(selectFlowFilterOption, "download");
  };


  const downloadXLSFile = async () => {
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
        selectedTimePeriodData &&
        selectedTimePeriodData !== "Time Period" &&
        selectedTimePeriodData?.length > 0 &&
        selectedTimePeriodData[0] !== "Time Period" &&
        selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";
    // console.log("Time Period Join_______________________________________", timePeriodValues)
    const filterList = filterRequest.filter((elem: any) => elem.value != "");

    //const requestParam = { "usecaseId": selectedUsecaseId, "category_id": selectedCategoryId,"folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": selectedScenarioId === 0 ?"tblLandedCost" : "tblScenario_LandedCost", "time_period": "", "filter": filterList };
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
        selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: scenarioId === 0 ? "tblLandedCost" : "tblScenario_LandedCost",
      time_period: "",
      filter: filterList,
    };
    const urls = API_BASE_URL + DOWNLOAD_LANDED_COST_TABLE_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };

  return (
    <>
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>Flows</h3>
          </div>
          <div className="filters">
            {/* <RestoreOutlinedIcon className="restoreIcon" onClick={(e) => handleRestoreClicked(e)}/> */}

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Select Flow</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectFlowFilterOption}
                  placeholder="Select Flows"
                  onChange={handleChangeSelectFlowFilter}
                  // defaultValue={selectFlowFilterOption?.displayName[0]}
                  renderValue={(selectFlowFilterOption: any) =>
                    selectFlowFilterOption?.displayName
                  }
                  className="select-short-term"
                >
                  {filterDropdownOptions.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d} style={{ fontSize: "15px" }}>
                        {d.displayName}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <div className="filter-item">
              <FormControl fullWidth>
                <div className="content-download-btn" onClick={handleDownload}>
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <div>
        <CGOFlowTables
          isProcessed={isProcessed}
          rowsData={rowsData}
          columns={tableColumnsDef}
        />
      </div>
    </>
  );
}

export default LandedCost;
